<template>
  <v-app class="futuristic-app">
    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-chart-box-outline </v-icon>
          </div>

          <div>
            <div class="header-info-title">Rekap Bencana</div>
            <div class="header-info-subtitle">Peta sebaran bencana Bondowoso</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="px-6 fill-height align-start">
        <v-row class="fill-height mt-2" no-gutters>
          <v-col cols="12" md="8" class="pr-md-3 fill-height">
            <v-card
              class="cyber-map-container overflow-hidden full-height-card"
              style="position: relative"
            >
              <div class="map-corners">
                <div class="c-tl"></div>
                <div class="c-tr"></div>
                <div class="c-bl"></div>
                <div class="c-br"></div>
              </div>
              <div id="map"></div>
              <div class="map-legend-overlay pa-3">
                <div class="white--text text-overline mb-2">Klasifikasi Kejadian</div>
                <div class="d-flex flex-column gap-1">
                  <div
                    v-for="(color, type) in kategoriWarna"
                    :key="type"
                    class="d-flex align-center mb-1"
                  >
                    <div class="legend-dot mr-2" :style="{ background: color }"></div>
                    <span class="white--text" style="font-size: 9px">{{ type }}</span>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="4"
            class="pl-md-3 fill-height d-flex flex-column"
            style="max-height: calc(100vh - 140px)"
          >
            <v-card class="panel-right pa-6 flex-grow-1 overflow-y-auto custom-scrollbar">
              <div v-if="selectedInfo">
                <div class="d-flex justify-space-between align-start mb-2">
                  <div>
                    <v-chip
                      label
                      x-small
                      :color="getWarnaBencana(selectedInfo.jenis_kejadian)"
                      class="mb-2 font-weight-bold white--text"
                    >
                      {{ selectedInfo.jenis_kejadian }}
                    </v-chip>
                    <div class="black--text text-h4 font-weight-black text-uppercase">
                      {{ selectedInfo.desa }}
                    </div>
                    <div class="gold--text caption font-weight-bold">
                      {{ selectedInfo.nama_kecamatan }}
                    </div>
                  </div>
                  <v-btn icon color="white" small @click="selectedInfo = null"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                </div>

                <div class="black--text caption mb-4 font-italic grey--text">
                  <v-icon x-small color="grey">mdi-map-marker</v-icon>
                  {{ selectedInfo.jalan_dusun_rt_rw }}
                </div>

                <div class="data-box-kerugian pa-4 rounded-lg mb-4 text-center">
                  <div class="gold--text overline mb-n1">ESTIMASI KERUGIAN</div>
                  <div class="black--text text-h5 font-weight-black">
                    Rp {{ selectedInfo.taksiran_kerugian || "0" }}
                  </div>
                </div>

                <div class="gold--text overline mb-2">Dampak Manusia</div>
                <v-row dense class="mb-4">
                  <v-col cols="6">
                    <div class="data-box pa-3 rounded-lg text-center border-left-blue">
                      <div class="black--text text-h6 font-weight-black">
                        {{ selectedInfo.terdampak_kk || 0 }}
                      </div>
                      <div class="grey--text caption">KK TERDAMPAK</div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="data-box pa-3 rounded-lg text-center">
                      <div class="black--text text-h6 font-weight-black">
                        {{
                          parseInt(selectedInfo.jiwa_pria || 0) +
                          parseInt(selectedInfo.jiwa_perempuan || 0)
                        }}
                      </div>
                      <div class="grey--text caption">TOTAL JIWA</div>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="data-box pa-2 d-flex align-center rounded-lg">
                      <v-icon x-small color="blue" class="mr-2">mdi-gender-male</v-icon>
                      <span class="black--text caption"
                        >Pria: <b>{{ selectedInfo.jiwa_pria || 0 }}</b></span
                      >
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="data-box pa-2 d-flex align-center rounded-lg">
                      <v-icon x-small color="pink" class="mr-2">mdi-gender-female</v-icon>
                      <span class="black--text caption"
                        >Wanita: <b>{{ selectedInfo.jiwa_perempuan || 0 }}</b></span
                      >
                    </div>
                  </v-col>
                </v-row>

                <div class="gold--text overline mb-2">Kelompok Rentan & Korban</div>
                <v-row dense class="mb-4">
                  <v-col cols="4">
                    <div class="data-box pa-2 text-center rounded-lg">
                      <div class="red--text font-weight-bold">
                        {{ selectedInfo.meninggal || 0 }}
                      </div>
                      <div class="grey--text" style="font-size: 8px">MENINGGAL</div>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="data-box pa-2 text-center rounded-lg">
                      <div class="orange--text font-weight-bold">
                        {{ selectedInfo.luka || 0 }}
                      </div>
                      <div class="grey--text" style="font-size: 8px">LUKA-LUKA</div>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div class="data-box pa-2 text-center rounded-lg">
                      <div class="black--text font-weight-bold">
                        {{
                          parseInt(selectedInfo.lansia_pria || 0) +
                          parseInt(selectedInfo.lansia_wanita || 0)
                        }}
                      </div>
                      <div class="grey--text" style="font-size: 8px">LANSIA</div>
                    </div>
                  </v-col>
                </v-row>

                <div class="gold--text overline mb-2">Kerusakan Fisik</div>
                <div class="item-glass pa-3 rounded-lg mb-4">
                  <div class="d-flex justify-space-between mb-1">
                    <span class="grey--text caption">Rumah Rusak (B/S/R)</span>
                    <span class="black--text font-weight-bold">
                      {{ selectedInfo.rumah_rusak_berat || 0 }} /
                      {{ selectedInfo.rumah_rusak_sedang || 0 }} /
                      {{ selectedInfo.rumah_rusak_ringan || 0 }}
                    </span>
                  </div>
                  <v-divider class="rgba-white-1 my-2"></v-divider>
                  <div class="d-flex justify-space-between mb-1">
                    <span class="grey--text caption">Fasum Terdampak</span>
                    <span class="black--text font-weight-bold">{{
                      selectedInfo.fasum_terdampak || 0
                    }}</span>
                  </div>
                  <div class="d-flex justify-space-between mb-1">
                    <span class="grey--text caption">Kios / Toko / Pabrik</span>
                    <span class="black--text font-weight-bold">{{
                      selectedInfo.kios_toko_pabrik || 0
                    }}</span>
                  </div>
                  <div class="d-flex justify-space-between">
                    <span class="grey--text caption">Hutan / Lahan (Ha)</span>
                    <span class="black--text font-weight-bold">{{
                      selectedInfo.hutan_lahan_ha || 0
                    }}</span>
                  </div>
                </div>

                <div class="mt-4">
                  <div class="grey--text overline mb-1">Waktu Laporan</div>
                  <div class="black--text caption">{{ selectedInfo.tanggal }}</div>
                </div>
              </div>

              <div
                v-else
                class="grey--text text-center py-10 d-flex flex-column align-center justify-center fill-height"
              >
                <v-icon size="64" color="rgba(255,255,255,0.05)">mdi-map-search</v-icon>
                <div class="mt-4 font-italic caption text-uppercase">
                  Pilih Titik Lokasi pada Peta
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getRekapBencana } from "@/api/androidInitApi";

export default {
  data: () => ({
    map: null,
    rekapData: [],
    selectedInfo: null,
    kategoriWarna: {
      KEBAKARAN: "#FF3D00",
      BANJIR: "#2979FF",
      "ANGIN KENCANG": "#FFEA00",
      LONGSOR: "#795548",
      GEMPA: "#E91E63",
      LAINNYA: "#00E676",
    },
  }),
  async mounted() {
    this.initMap();
    await this.fetchData();
  },
  methods: {
    getWarnaBencana(jenis) {
      if (!jenis) return "#00E676";
      const j = jenis.toUpperCase();
      for (const [key, color] of Object.entries(this.kategoriWarna)) {
        if (j.includes(key)) return color;
      }
      return this.kategoriWarna["LAINNYA"];
    },
    async fetchData() {
      try {
        this.rekapData = (await getRekapBencana()) || [];
        this.renderMarkers();
      } catch (e) {
        console.error(e);
      }
    },
    initMap() {
      this.map = L.map("map", { zoomControl: false, attributionControl: false }).setView(
        [-7.9135, 113.8217],
        11
      );
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);
      this.loadMasking();
    },
    async loadMasking() {
      try {
        const res = await fetch("/images/35.11_kecamatan.geojson");
        const geoData = await res.json();
        const world = [
          [
            [-90, -180],
            [-90, 180],
            [90, 180],
            [90, -180],
            [-90, -180],
          ],
        ];
        geoData.features.forEach((f) => {
          if (f.geometry.type === "Polygon")
            world.push(f.geometry.coordinates[0].map((c) => [c[1], c[0]]));
          else
            f.geometry.coordinates.forEach((p) =>
              world.push(p[0].map((c) => [c[1], c[0]]))
            );
        });
        L.polygon(world, {
          color: "black",
          weight: 0,
          fillColor: "#000",
          fillOpacity: 0.9,
          interactive: false,
        }).addTo(this.map);

        L.geoJson(geoData, {
          style: { color: "#018c74", weight: 1.5, fillColor: "transparent" },
          onEachFeature: (feature, layer) => {
            if (feature.properties && feature.properties.NAMOBJ) {
              const labelIcon = L.divIcon({
                className: "kecamatan-label",
                html: `<span>${feature.properties.NAMOBJ}</span>`,
                iconSize: [100, 20],
              });
              const center = layer.getBounds().getCenter();
              L.marker(center, { icon: labelIcon, interactive: false }).addTo(this.map);
            }
          },
        }).addTo(this.map);
      } catch (e) {
        console.error(e);
      }
    },
    renderMarkers() {
      this.rekapData.forEach((item) => {
        if (!item.koordinat) return;
        const coords = item.koordinat.split(",").map((c) => parseFloat(c.trim()));
        const warna = this.getWarnaBencana(item.jenis_kejadian);
        const icon = L.divIcon({
          className: "cyber-marker",
          html: `<div class="marker-pulse" style="background: ${warna}44"></div><div class="marker-core" style="background: ${warna}; box-shadow: 0 0 15px ${warna}"></div>`,
          iconSize: [20, 20],
          iconAnchor: [10, 10],
        });
        L.marker(coords, { icon })
          .addTo(this.map)
          .on("click", () => {
            this.selectedInfo = item;
          });
      });
    },
  },
};
</script>


<style scoped>
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}

.full-height-card {
  height: calc(100vh - 140px);
  border-radius: 24px !important;
}
#map {
  height: 100%;
  width: 100%;
  background: var(--bg-teal-dark);
}



.cyber-map-container {
  border: 1px solid rgba(45, 138, 122, 0.35) !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2) !important;
  border-radius: 20px;
}

.panel-right {
  background: #f5f5f5 !important;
  backdrop-filter: blur(20px);
  border-radius: 24px !important;
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
  color: var(--text-primary) !important;
}

.data-box {
  background: #f5f5f5;
  border: 1px solid rgba(45, 138, 122, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.border-left-blue {
  border-left: 3px solid var(--accent-teal) !important;
}
.data-box-kerugian {
  background: rgba(255, 167, 38, 0.1);
  border: 1px solid rgba(255, 167, 38, 0.3);
}
.item-glass {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(45, 138, 122, 0.2);
}

.map-legend-overlay {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 999;
  background: var(--bone-white);
  border-radius: 12px;
  width: 140px;
  border: 1px solid rgba(45, 138, 122, 0.3);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  color: var(--text-primary) !important;
}
.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

:deep(.kecamatan-label) {
  background: transparent !important;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.kecamatan-label span) {
  color: var(--bone-white);
  font-size: 8px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.9);
  white-space: nowrap;
  pointer-events: none;
}

.map-corners div {
  position: absolute;
  width: 30px;
  height: 30px;
  border: 3px solid var(--accent-gold);
  z-index: 10;
  pointer-events: none;
}
.c-tl {
  top: 15px;
  left: 15px;
  border-right: 0;
  border-bottom: 0;
}
.c-tr {
  top: 15px;
  right: 15px;
  border-left: 0;
  border-bottom: 0;
}
.c-bl {
  bottom: 15px;
  left: 15px;
  border-right: 0;
  border-top: 0;
}
.c-br {
  bottom: 15px;
  right: 15px;
  border-left: 0;
  border-top: 0;
}

:deep(.cyber-marker) {
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep(.marker-core) {
  width: 10px;
  height: 10px;
  border: 2px solid var(--bone-white);
  border-radius: 50%;
  background: var(--accent-teal);
  box-shadow: 0 2px 8px rgba(38, 166, 154, 0.4);
}
:deep(.marker-pulse) {
  position: absolute;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: rgba(255, 167, 38, 0.3);
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

.gold--text {
  color: var(--accent-gold) !important;
}
.rgba-white-1 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: var(--accent-teal);
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: var(--accent-gold);
}

@media (max-width: 768px) {
  .map-legend-overlay {
    width: 120px;
    top: 12px;
    right: 12px;
  }
  .map-corners div {
    width: 20px;
    height: 20px;
    border-width: 2px;
  }
}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 20 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
